<template>
  <div style="height:100%;">
    <div class="zhwl-card flex">
      <div
        class="row"
        v-for="(item, index) in qxzList"
        :key="index"
        :class="isChoose === index ? 'check' : ''"
        @click="rowClick(item, index)"
      >
        <div style="color:#01ceeb">
          <img
            width="20px"
            style="vertical-align:middle;margin:0 auto"
            :src="item.src"
          />
          {{ item.name }}
        </div>
        <div class="flex" style="justify-content:center">
          <span class="num" style="font-size:17px" :id="'num' + index">
            {{ item.value ? item.value : "-" }}
          </span>
          {{ item.unit }}
        </div>
      </div>
    </div>
    <div class="chartsBox">
      <!-- <div class="charts" ref="qx"></div> -->
      <loadEchart ref="echarts"></loadEchart>
    </div>
  </div>
</template>

<script>
import { getIndexByPositionCode } from "@/api/base";
import { findRealData, findHistoryData } from "@/api/zhwl";
import { deviceOption } from "@/util/deviceOption";
export default {
  data() {
    return {
      list: [],
      deviceCode: "",
      isChoose: 0,
      zhwlList: [],
      key: null,
      unit: "m/s",
      form: {},
      qxObj: {
        // 图标对照表
        温度: require("images/index/zhwl/icon_wd.png"),
        湿度: require("images/index/zhwl/icon_sd.png"),
        风向: require("images/index/zhwl/icon_fx.png"),
        风速: require("images/index/zhwl/icon_fs.png"),
        气压: require("images/index/zhwl/icon_qy.png"),
        雨量: require("images/index/zhwl/icon_yl.png"),
      },
      timeIndex: 2,
      equimentIds: [],
      equimentTimes: [],
      qxzList: [
        {
          name: "温度",
          value: "--",
          channel: "3",
          unit: "℃",
          img: require("images/index/zhwl/icon_wd.png"),
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
        {
          name: "湿度",
          value: "--",
          channel: "6",
          unit: "%",
          img: require("images/index/zhwl/icon_sd.png"),
          type: "humi",
          indexs: [],
          echartsData: [],
        },
        {
          name: "风向",
          value: "--",
          channel: "5",
          unit: "",
          img: require("images/index/zhwl/icon_fx.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "风速",
          value: "--",
          channel: "5",
          unit: "m/s",
          img: require("images/index/zhwl/icon_fs.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "气压",
          value: "--",
          channel: "5",
          unit: "m/s",
          img: require("images/index/zhwl/icon_qy.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "雨量",
          value: "--",
          channel: "5",
          unit: "mm",
          img: require("images/index/zhwl/icon_yl.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
      ],
      qxCharts: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$refs.echarts.showLoading();
      // getWlwCode().then((res) => {
      let res = {
        data: window.deviceData,
      };
      if (res && res.data && res.data.weather)
        this.deviceCode = res.data.weather;
      else this.deviceCode = "CJGCA-000038";
      findRealData(this.deviceCode)
        .then((res) => {
          console.log("设备", res.data, res.data.sensor.length);
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0
          ) {
            const sensor = res.data.sensor;
            this.qxzList.map((item) => {
              sensor.some((ele) => {
                if (ele.name.indexOf(item.name) > -1) {
                  this.equimentIds.push(ele.id);
                  item.id = ele.id;
                  item.name = ele.name;
                  item.unit = ele.sensor_type_unit || ele.unit || "";
                  item.value = ele.value || "";
                  item.channel = ele.channel;
                  item.echartsData = [];
                  item.indexs = [];
                  return true;
                }
              });
              return item;
            });
            console.log(
              "气象站",
              sensor,
              this.qxzList,
              this.equimentIds.length > 0
            );
            if (this.equimentIds.length > 0) this.getHistoryData();
          } else this.$refs.echarts.noOption();
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
      // });
    },
    rowClick(item, index) {
      if (index == this.isChoose) return;
      this.isChoose = index;
      // this.form = item;
      this.$refs.echarts.setOptions(this.getOptions());
    },
    handleMore() {
      getIndexByPositionCode({ positionCode: "zhwl" }).then((res) => {
        if (res.code === 200) {
          this.$store.dispatch("map/setLayerIndexId", res.data[0].zb_indexId);
          this.$store.dispatch("map/setLayerComponent", "zhwlLayer");
        }
      });
    },

    getHistoryData(
      ids = "equimentIds",
      type = "qxzList",
      timeType = "equimentTimes"
    ) {
      this.$refs.echarts.showLoading();
      console.log("getHistoryData");
      let start_time = `${this.$formatDate(new Date(), "yyyy-MM-dd")} 00:00:00`;
      // if (this.timeIndex == 1)
      //   start_time = `${this.$formatDate(
      //     this.$funGetDate(-3),
      //     "yyyy-MM-dd"
      //   )} 00:00:00`;
      // else if (this.timeIndex == 2)
      //   start_time = `${this.$formatDate(
      //     this.$funGetDate(-7),
      //     "yyyy-MM-dd"
      //   )} 00:00:00`;
      // else if (this.timeIndex == 3)
      //   start_time = `${this.$formatDate(
      //     this.$funGetDate(-15),
      //     "yyyy-MM-dd"
      //   )} 00:00:00`;
      const end_time = this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      let group_type = this.timeIndex == 0 ? 5 : 4;
      const data = {
        sensor_ids: this[ids].join(","),
        group_type,
        start_time,
        end_time,
      };
      console.log("end_time", this.timeIndex, data);
      debugger;
      findHistoryData(data)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0 &&
            res.data.time &&
            res.data.time.length > 0
          ) {
            const datas = res.data;
            this[timeType] = datas.timestamp.map((it) => {
              return this.$formatDate(new Date(it), "MM-dd hh时");
            });
            this[type].map((item) => {
              datas.sensor.some((it) => {
                if (it.hd_device_sensor_channel == item.channel) {
                  item.echartsData = it.data ? it.data : it.avg_data;
                  item.indexs = it.index;
                  return true;
                }
              });
              return item;
            });
            console.log("数据", this.qxzList);
            this.$refs.echarts.setOptions(this.getOptions());
          }
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
    },
    getOptions() {
      let data = this.qxzList[this.isChoose];
      return deviceOption(
        data.name,
        this.equimentTimes,
        data.echartsData,
        data.unit,
        data.indexs
      );
    },
  },
  destroyed() {
    clearInterval(this.key);
    window.removeEventListener("resize", () => {
      this.qxCharts.resize();
    });
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.content
  height 28%

.bar
  background-color #21446e

  .title
    color #fff
    padding 10px 8px
    flex 1
    text-align center
    cursor pointer
    white-space nowrap

    @media (max-width 1460px)
      text-overflow ellipsis
      overflow hidden

  .tabChoose
    color #04d2eb

  .video
    color #04D2EB
    cursor pointer

    span
      padding-bottom 1px
      border-bottom 1px solid

.zhwl-card
  // padding-top 5px
  padding-top 1px
  height .4rem
  box-sizing border-box
  .row
    text-align center
    cursor pointer
    color #fff
    justify-content space-between
    padding 3px
    min-width 16%
    box-sizing border-box
    border-right 1px solid #0ff
  .row:last-child
    border-right 0
    .line
      display inline-block
      border-top 1px dashed #04D2EB
      width 100%

.check
  background #335873
.chartsBox
  position relative
  width 100%
  // height calc(100% - 52px)
  height calc(100% - .4rem)
.charts
  width 100%
  height 100%
</style>
